import { Category } from './FilterLoanList.types';

export const LOAN_FILTERS: Category[] = [
  'loanType',
  'creditLimitFloor',
  'bank',
];
